import React, {Component} from 'react';
import {tutils, PropTypes} from 'subschema';
import _require from 'react/lib/ReactInputSelection';
var getSelection = _require.getSelection;
var setSelection = _require.setSelection;

var {noop} = tutils;

export default class CapitalInput extends Component {
    static contextTypes = PropTypes.contextTypes;

    static defaultProps = {
        "onValid": noop,
        "value": ''
    };

    static propTypes = {
        "onChange": PropTypes.valueEvent,
        "onValid": PropTypes.validEvent
    };

    constructor(props, ...rest) {
        super(props, ...rest);
        this.state = {
            compositionStart: false
        };
    }

    handleOnChange = () => {
        // Return if the user is using Input Method Editor https://w3c.github.io/ime-api/Annex.html
        // which will be handled by onCompositionStart and onCompositionEnd.
        if (this.state.compositionStart) return;

        var r = this.refs.capitalinput;
        var curPos = getSelection(r);
        r.value = r.value.replace(/\b./g, (a) => a.toUpperCase());
        setSelection(r, curPos);
        this.props.onChange(r.value);
    }

    handleCompositionStart = () => {
        this.setState({
            compositionStart: true
        });
    }

    handleCompositionEnd = () => {
        this.setState({
            compositionStart: false
        });
    }

    render() {
        var {value, onKeyDown, onChange, ...props} = this.props;

        return (
          <input
              ref="capitalinput"
              defaultValue={value}
              onChange={this.handleOnChange}
              onCompositionStart={this.handleCompositionStart}
              onCompositionEnd={this.handleCompositionEnd}
              {...props}
          />
        );
    }
};


/** WEBPACK FOOTER **
 ** ./src/types/input/CapitalInput.jsx
 **/